// extracted by mini-css-extract-plugin
export var centerText = "_7c-8";
export var container = "_7c-0";
export var doughnutContainer = "_7c-7";
export var legend = "_7c-a";
export var legendItemColorDisplay = "_7c-b";
export var legendItemLabel = "_7c-d";
export var legendItemValue = "_7c-c";
export var lg = "_7c-5";
export var maxWidth = "_7c-9";
export var md = "_7c-4";
export var responsive = "_7c-6";
export var sm = "_7c-3";
export var xs = "_7c-2";
export var xxs = "_7c-1";